export enum ViewerBehaviourType {
    Popup = 0,
    Inline = 1
}
